// extracted by mini-css-extract-plugin
export default {"container":"CollectionUpdater_container__psuPZ","card":"CollectionUpdater_card__x-dck","modeLabel":"CollectionUpdater_modeLabel__YAbP-","input":"CollectionUpdater_input__iwki3"};